import { en, ru, fr, es, de, ja } from "vuetify/locale";
import { getFallbackLocale, parseExcludedLocales } from "~/utils/excludedLocales";
import enL from "~/locales/en.json";
import ruL from "~/locales/ru.json";
import frL from "~/locales/fr.json";
import esL from "~/locales/es.json";
import deL from "~/locales/de.json";
import jaL from "~/locales/ja.json";
const messages = {
	en: {
		...enL,
		$vuetify: { ...en }
	},
	ru: {
		...ruL,
		$vuetify: { ...ru }
	},
	fr: {
		...frL,
		$vuetify: { ...fr }
	},
	es: {
		...esL,
		$vuetify: { ...es }
	},
	de: {
		...deL,
		$vuetify: { ...de }
	},
	ja: {
		...jaL,
		$vuetify: { ...ja }
	}
};
export default () => {
	const runtimeConfig = useRuntimeConfig();
	const defaultLocale = getFallbackLocale(parseExcludedLocales(runtimeConfig.public.excludedLocales), runtimeConfig.public.defaultLocale);
	return {
		strategy: "prefix",
		legacy: false,
		locale: defaultLocale,
		fallbackWarn: false,
		missingWarn: false,
		fallbackLocale: defaultLocale,
		messages
	};
};
